import type { API } from 'chessboard/api/config/types';
import JCE from '@chesscom/js-chess-engine';

/**
 * Create the getPositionDetails proxy method
 * for JCE.getPositionDetails()
 */
export function createGetPositionDetails(context: API.Context) {
  /**
   * Get a position details with the optional Move model.
   *
   * If move was provided, then it will be added to the end of Move List
   * and function will return details for the resulting position.
   *
   * If not - for the current position.
   */
  return function getPositionDetails(
    move?: JCE.Move.Model | JCE.Move.Attempt | JCE.Move.DropAttempt,
  ): JCE.Position.Details | null {
    const pgn = context.api.getPGN();

    return JCE.getPositionDetails({ pgn }, move);
  };
}
